import { render } from "./CommandEvent.vue?vue&type=template&id=7951200f"
import script from "./CommandEvent.vue?vue&type=script&lang=js"
export * from "./CommandEvent.vue?vue&type=script&lang=js"

import "./CommandEvent.vue?vue&type=style&index=0&id=7951200f&lang=css"
script.render = render

export default script